import styled from '@emotion/styled';
import { Grid, Box } from '@material-ui/core';
import { Button, Magnetic } from '@mitchell/react.component.ux';
export const StyledUploadButton = styled(Button) `
	height: 70px;
	width: 70px;
	border: dashed ${Magnetic.colorBrand50};
	background-color: ${Magnetic.colorWhite};
	margin: ${Magnetic.spacer06} ${Magnetic.spacer04} ${Magnetic.spacer08} 0;
	padding: ${Magnetic.spacer04} ${Magnetic.spacer08};
`;
export const StyledDivGalleryView = styled('div') `
	display: inline-flex;
	flex-wrap: wrap;
	width: 100%;
	gap: ${Magnetic.spacer08};
`;
export const StyledFileUploaderContainer = styled('div') `
	width: 100%;
	display: flex;
	align-items: center;
	flex-direction: column;
`;
export const StyledHeading = styled('p') `
	font-weight: ${Magnetic.fontWeightHeavy};
	font-size: ${Magnetic.fontSize14};
`;
export const StyledHeadingContainer = styled(Box) `
	display: flex;
	align-items: center;
`;
export const StyledUploadedImagesContainer = styled('div') `
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	gap: ${Magnetic.spacer08};
`;
export const StyledTextContainer = styled('div') `
	display: flex;
	width: 100%;
	justify-content: space-between;
	gap: ${Magnetic.spacer06};
`;
export const StyledClickableText = styled('p') `
	font-weight: ${Magnetic.fontWeightHeavy};
	font-size: ${Magnetic.fontSize14};
	color: ${Magnetic.colorBrand05};
	cursor: ${Magnetic.actionableCursor};
	white-space: nowrap;
`;
export const StyledDivInlineView = styled('div') `
	cursor: ${Magnetic.actionableCursor};
`;
export const StyledGridInnerContainer = styled(Grid) `
	background-color: ${Magnetic.colorNeutral10};
	.carousel-slider {
		overflow: hidden;
	}

	li.slide {
		background-color: transparent;
		flex-flow: column;
		min-width: 100%;
		margin: 0;
		position: relative;
		text-align: center;
		align-items: center;
		justify-content: center;
		display: flex;
	}

	li.slide > div {
		height: 100%;
		margin: ${Magnetic.spacer12} 0px;
	}
	.carousel .slide img {
		max-height: 100%;
		max-width: 100%;
		object-fit: contain;
		position: relative;
		top: 50%;
		left: 0;
		padding: 0px ${Magnetic.spacer04};
	}
	.carousel .slider {
		transform: translate3d(0px, 0px, 0px);
		transition-duration: 0ms;
		margin: 0;
		padding: 0;
		position: relative;
		list-style: none;
		width: 100%;
		display: flex;
	}
	#btn-right-nav {
		top: 26%;
		right: 1px;
	}
	#btn-left-nav {
		top: 26%;
		left: -1px;
	}
`;
export const GridItem = styled(Grid) `
	width: 100%;
	border: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.colorNeutral20};
`;
export const StyledGridPhotoCaptureItem = styled(GridItem) `
	width: 100%;
	height: 300px;
	border-bottom: 0px;
`;
export const StyledGridContainer = styled(StyledGridInnerContainer) `
	border-top: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.colorBrand20};
`;
export const StyledFileName = styled('p') `
	font-size: ${Magnetic.fontSize16};
	margin: ${Magnetic.spacer12};
	word-break: break-all;
`;
export const StyledGridTextRightItem = styled(Grid) `
	text-align: right;
	margin-top: ${Magnetic.spacer12};
`;
export const StyledButtonTextItem = styled('p') `
	font-weight: ${Magnetic.fontWeightSemibold};
	margin: ${Magnetic.spacer08} 0 ${Magnetic.spacer08} ${Magnetic.spacer08};
	font-size: ${Magnetic.fontSize16};
	display: inline-flex;
	align-items: center;
	color: ${Magnetic.colorBrand50};
	cursor: ${Magnetic.actionableCursor};
	&:hover {
		color: ${Magnetic.colorBrand40};
		cursor: ${Magnetic.actionableCursor};
	}
	p>button {
		padding ${Magnetic.spacer06} ${Magnetic.spacer08}
	}
`;
export const StyledTextCenter = styled('p') `
	font-size: ${Magnetic.fontSize16};
	margin: ${Magnetic.spacer12};
`;
export const StyledDivPopUpBody = styled('div') `
	display: inherit;
	text-align: center;
	width: 100%;
	&div {
		text-align: left;
	}
`;
export const StyledDivModalContent = styled('div') `
	text-align: left;
`;
export const StyledMultiCommentContainer = styled('div') `
	width: 100%;
	margin: 0 ${Magnetic.spacer06};
`;
//# sourceMappingURL=PhotoCaptureThumbnailGallery.style.js.map